import { lazyLoad } from 'utils/loadable';

export const FileManager = lazyLoad(() => import('./index'));
